module.exports = __webpack_public_path__ + "img/layout_horizontal_right.67f96e78.svg";